<template>
  <div class="top-filters">
    <router-link-modified v-for="(filter, index) in popularFilters"
                          :key="index"
                          :id="'vacancy-popular-filter-' + index"
                          tag="div"
                          :to="getRoute(filter)"
                          :class="`top-filters__item  base-btn base-btn--outline-dark base-btn--small ${isActive(filter)}`">
      <span>{{ filter.title }}</span>
    </router-link-modified>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        bindedClickLinkListeners: [],
      }
    },
    computed: {
      ...mapState('vacancies', [
          'popularFilters',
          'otherKeys',
      ])
    },
    mounted() {
      this.addClickListeners();
    },
    methods: {
      addClickListeners() {
        for (const index in this.popularFilters) {
          this.bindedClickLinkListeners.push(this.clickLinkListener.bind(this, index));

          const $el = document.getElementById(`vacancy-popular-filter-${index}`);
          $el.addEventListener('click', this.bindedClickLinkListeners[index], true);
        }
      },
      clickLinkListener(index, $event) {
        const result = [];
        const filter = this.popularFilters[index];

        filter.data.forEach(group => {
          group.data.forEach(item => {
            result.push(item.slug);
          })
        });

        if (this.$route.params.dynamicFilters === result.join('-') && this.$route.query[this.otherKeys.SORT] === this.$route.query[this.otherKeys.SORT]) {
          $event.preventDefault();
          this.$router.push({ name: 'vacancies' });
        }
      },
      isActive(filters) {
        const result = []
        let link = {...this.$route.params}.dynamicFilters

        if (link) {
          filters.data.map(group => {
            group.data.map(item => {
              result.push(item.slug)
              link = link.replace(item.slug, '')
            })
          })

          const isUnique = result.every(val => {
            return this.$route.fullPath.includes(val)
          })

          return isUnique && /^[-]+$/.test(link) ? '_active' : null
        }

        return null
      },
      getRoute(filters) {
        const result = []

        filters.data.forEach(group => {
          group.data.forEach(item => {
            result.push(item.slug)
          })
        })

        return {
          name: 'vacancies-with-dynamic',
          params: {
            dynamicFilters: result.join('-')
          },
          query: {
            [this.otherKeys.SORT]: this.$route.query[this.otherKeys.SORT],
          }
        }
      }

      // getRoute(filter) {
      //   const route = {}
      //
      //   const paramsStatic = []
      //   const paramsDynamic = []
      //
      //   for (const item of filter.stack) {
      //     let slugValue = Array.isArray(item.param_value_slug) ? item.param_value_slug : [item.param_value_slug]
      //     slugValue = slugValue.join('|').replace('-', '_')
      //     const itemResult = item.param_slug.replace('-', '_') + '-' + slugValue
      //     if (item.type === 's') {
      //       paramsStatic.push(itemResult)
      //     } else if (item.type === 'd') {
      //       paramsDynamic.push(itemResult)
      //     }
      //   }
      //
      //   if (paramsStatic.length && paramsDynamic.length) {
      //     route.name = 'vacancies-with-filters&dynamic'
      //     route.params = {
      //       filters: paramsStatic,
      //       dynamic: paramsDynamic
      //     }
      //   } else if (paramsStatic.length) {
      //     route.name = 'vacancies-with-filters'
      //     route.params = {
      //       filters: paramsStatic
      //     }
      //   } else if (paramsDynamic.length) {
      //     route.name = 'vacancies-with-dynamic'
      //     route.params = {
      //       dynamic: paramsDynamic
      //     }
      //   }
      //
      //   return route
      // }
    }
  }
</script>

<style lang="less">

</style>
